import {Pagination} from '../pagination.model';
import {OperatingUnit} from '../../../../operating-units/shared/model/operating-unit.model';

export class OperatingUnitPage extends Pagination {
  content: OperatingUnit[] = [];
}
